import { empty } from 'patronum';
import { accountTreeModel } from 'entities/account';
import { createTransactionRegistryModel } from 'entities/transaction';
import { accountPageModel } from './account-page-model';

const transactionRegistryModel = createTransactionRegistryModel({
	$accountId: accountPageModel.$accountId,
	disabled: empty(accountPageModel.$accountId),
	currencies: accountTreeModel.$currencies,
	onUpdate: [accountPageModel.$accountId],
});

export const accountPageTransactionsModel = {
	transactionRegistryModel,
};
